import SubmenuMobile from './custom_menu/submenu_mobile'
import LangMenu from './custom_menu/langmenu'

export default class CustomSuperfish {
  openMenuMobile = false

  constructor(elParent, elLangMenu){
    this.elParent = elParent
    this.elLangMenu = elLangMenu
    this.menuMobile = this.elParent.find('.sf-main-menu.sf-accordion')

    this.customSlideSubmenu()
  }

  customSlideSubmenu(){
    const self = this
    this.menuMobile.find('li:not(.sf-no-children)').click(function(e){
      self.submenu = new SubmenuMobile( jQuery(this) )
    })

    this.elParent.find('.sf-accordion-toggle a').click(() => {
      if (this.openMenuMobile === false) {
          this.openMenuMobile = true
          this.menuMobile.removeClass('mhg-expanded-submenu')
          this.reDisplayLangMenu()
      }else{
        this.openMenuMobile = false
        this.reset()
      }
    })

    if( this.elLangMenu.length > 0 ){
      this.langMenu = new LangMenu(this.elLangMenu, this.menuMobile)
    }

    // jQuery( window ).resize(function() {})
  }

  reDisplayLangMenu(){
    const lastChild = this.menuMobile.children('li:last-child')
    const offset = lastChild.offset()
    this.elLangMenu.addClass('mhg-display-mobile').css('top', offset.top + lastChild.height())
  }

  reset(){
    this.menuMobile.removeClass('mhg-expanded-submenu')
    this.elLangMenu.removeClass('mhg-display-mobile')
    this.elLangMenu.css('top', 'auto')
  }

  destroy(refName) {
    this.reset()

    if(this.submenu)
      this.submenu.destroy()

    if(this.langMenu)
      this.langMenu.destroy()
  }
}



// WEBPACK FOOTER //
// ./src/custom_menu_mobile.js